<template>
	<v-container>
		<template>
			<div class="text-center">
				<v-dialog
				    v-model="dialog"
				    width="800"
                    @click:outside="closeModal"
                >
			        <v-card class="custom-card pb-120" rounded="0">
                        <v-toolbar
                            color="primary"
                            class="white--text"
                            >

                            <v-toolbar-title class="font-weight-bold">{{ $t('logs.activityLogDetails') }}</v-toolbar-title>

                            <v-spacer></v-spacer>

                            <v-btn icon class="white--text" @click="closeModal">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-list two-line>
                                <v-list-item>
                                    <v-list-item-avatar size="100">
                                        <v-img src="/img/user.jpg"></v-img>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold">{{ userName }}</v-list-item-title>
                                        <v-list-item-subtitle class="mt-1">{{ log.user ? log.user.email : '-' }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-divider></v-divider>
                            <v-row class="mt-5 mb-5 d-flex">
                                <v-col cols="4">
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{ $t('logs.time') }}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2">
                                            {{ formatDate(log.createdAt) }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-divider vertical inset></v-divider>
                                <v-col cols="4">
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{ $t('logs.userId') }}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2">
                                            {{ log.user_id || '-' }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-divider vertical inset></v-divider>
                                <v-col cols="3">
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{ $t('logs.role') }}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2 text-capitalize">
                                            {{ log.user ? log.user.role.split('_').join(' ') : '-' }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row class="mt-5 mb-5 d-flex">
                                <v-col cols="4">
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{ $t('logs.terminalID') }}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2">
                                            {{ log.ip_address || '-' }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-divider vertical inset></v-divider>
                                <v-col cols="4">
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{ $t('logs.moduleAccessed') }}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2">
                                            {{ log.activity_table || '-' }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-divider vertical inset></v-divider>
                                <v-col cols="3">
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{ $t('logs.typeOfAccess') }}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2">
                                            {{ log.activity_type || '-' }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row class="mt-5 mb-5 d-flex">
                                <v-col cols="4">
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{ $t('logs.userAgent') }}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2" style="white-space:normal;word-break:break-all;">
                                            {{ log.user_agent || '-' }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-divider vertical inset></v-divider>
                                <v-col cols="4">
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{ $t('logs.description') }}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2" style="white-space:normal;">
                                            {{ log.description || '-' }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-divider vertical inset></v-divider>
                                <v-col cols="3">
                                    <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                            {{ $t('logs.farmId') }}
                                            </v-list-item-subtitle>
                                            <v-list-item-title class="text-h6 mt-2">
                                            {{ log.farm_id || '-' }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </v-card-text>
			        </v-card>
		        </v-dialog>
	        </div>
        </template>
    </v-container>
</template>
<script>
import moment from "moment";

export default {
    computed: {
        dialog() {
            return this.dialogU;
        },
        userName() {
            if (!this.log.user) return '-'
            const name = [this.log.user.firstName, this.log.user.lastName].filter(Boolean).join(' ').trim()
            return name || this.log.user.email || this.log.user.mobile || '-'
        },
    },
    props: {
        'dialogU': {
            type: Boolean,
            required: true
        },
        'log': {
            required: true,
            type: Object
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeLogModal')
        },
        formatDate(val) {
            return val ? moment(val).format('YYYY-MM-DD HH:mm') : '-'
        },
    }
}
</script>
